import React, { useState } from 'react';
import CustomSelect from '../../Reusable/CustomSelect';

const SelectDemo = () => {
  const dataList = [
    {
      id: 1,
      name: 'admin',
      value: 'admin',
    },
    {
      id: 2,
      name: 'direktor',
      value: 'direktor',
    },
    {
      id: 3,
      name: 'autor',
      value: 'autor',
    },
  ];
  const [basicSelect, setBasicSelect] = useState(dataList[2].value);

  const onChangeHandler = (event) => {
    setBasicSelect(event.target.value);
  };

  return (
    <CustomSelect
      id={'basicSelect'}
      name={'basicSelect'}
      label={'Select'}
      data={dataList}
      textExtractor={(a) => a?.name}
      valueExtractor={(a) => a?.value}
      value={basicSelect}
      onChange={onChangeHandler}
    />
  );
};

export default SelectDemo;
